import { createSlice } from '@reduxjs/toolkit';

export const filterSlice = createSlice({
    name: 'filter',
    initialState: '',
    reducers: {
        changeFilterValue: (state, action) => action.payload.trim(),
    },
});

export const { changeFilterValue } = filterSlice.actions;

export default filterSlice.reducer;
